import React from 'react';
import Config from "../../config/Config";

const Analytics = () => {
    const style = {
        display: "none",
        visibility: "hidden",
        height: 0,
        width: 0
    }

    return (
        <noscript>
            <iframe title={Config.resources.GA_BODY} src={Config.resources.GA_BODY} style={style}/>
        </noscript>
    );
};

export default Analytics;
